import urlPrefix from "./apiPrefix";

export const getBusinessActivityList = () => `${urlPrefix.value}/tax-web-control/api/business-activity/list`;
